
// native
import { Injectable } from '@angular/core';

// models
import { IList, ListNode } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { }

  unflattenLists(lists: IList[], parent?: ListNode): ListNode {
    let tmp: ListNode[];
    let children: ListNode[];
    tmp = (lists || []).filter(child => {
      return parent ? child.parent_id === parent.list.id : !child.parent_id;
    }).map(list => {
      return new ListNode(list, [], parent);
    }).sort((a, b) => {
      return a.list.name.toLowerCase()
        .localeCompare(b.list.name.toLowerCase());
    });
    if (!parent) {
      children = tmp;
    } else {
      parent.children = tmp;
    }
    tmp.forEach(child => {
      this.unflattenLists(lists, child);
    });
    return new ListNode(null, children, null);
  }

  scrollToTop(el = document.querySelector('#scroll-wrapper-styles')) {
    if (!el) {
      return;
    }

    el.scrollTop = 0;
  }

  sortAlphabetically(list: object[], key: string) {
    list.sort((a, b) => {
      if (a[key] > b[key]) {
        return 1;
      }
      if (a[key] < b[key]) {
        return -1;
      }
      return 0;
    });
  }

  parseXMLStringToDocument = (xmlString: string): XMLDocument => {
    return new DOMParser().parseFromString(xmlString, "text/xml");
  };

  getPropOrNull(doc, prop) {
    try {
      return doc.getElementsByTagName(prop)[0];
    } catch (e) {
      return null;
    }
  };

  chunkify<T>(arr: Array<T>, size: number = 1): Array<Array<T>> {
    const chunks: Array<Array<T>> = [];
    for (let i = 0, j = arr.length; i < j; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }

  runInSequenceAsList<T>(jobs: (() => Promise<T[]>)[]): Promise<T[]> {
    const reducer = (previous, action, index): Promise<T[]> => {
      return previous.then((result: T[]) => action().then((r: T[]) => {
        return Array.prototype.concat.call(result, r);
      }));
    };

    return jobs.reduce(reducer, Promise.resolve([]));
  }

  runInSequenceAsMap<T>(jobs: (() => Promise<T>)[]): Promise<T> {
    const reducer = (previous, action, index): Promise<T> => {
      return previous.then((result: T) => action().then((r: T) => {
        return Object.assign(result, r);
      }));
    };

    return jobs.reduce(reducer, Promise.resolve({}));
  }

  strtrunc(str: string, len: number, useWordBoundary: boolean): string {
    if (str.length <= len) {
      return str;
    }
    const s = str.substr(0, len - 1);
    return (useWordBoundary ? s.substr(0, s.lastIndexOf(' ')) : s) + '...';
  }

  findArrayMemberIndexWithProp(array: any[], prop: string, value: any): number {
    for (let i = 0; i < array.length; i += 1) {
      if (array[i][prop] === value) {
        return i;
      }
    }
    return -1;
  }

  filterExisting(items: any[]): any[] {
    return items.filter(item => !!item);
  }

  getYearFromMetadata(val) {
    if (!val)
      return;

    if (/^\d{1,4}$/.test(val) && val > 0)
      return val;

    let dateParts = /^(\d{1,4})-(\d{1,2})$/.exec(val);

    const hasYearMonth =
      dateParts
      && dateParts[1] && (parseInt(dateParts[1]) > 0)
      && dateParts[2] && (parseInt(dateParts[2]) > 0);

    if (hasYearMonth)
      return dateParts[1];

    dateParts = /^(\d{1,4})-(\d{1,2})-(\d{1,2})$/.exec(val);

    const hasYearMonthDate =
      dateParts
      && dateParts[1] && (parseInt(dateParts[1]) > 0)
      && dateParts[2] && (parseInt(dateParts[2]) > 0)
      && dateParts[3] && (parseInt(dateParts[3]) > 0);

    if (hasYearMonthDate)
      return dateParts[1];
  }

  get isInternetExplorer() {
    return ((window.navigator.userAgent.indexOf("MSIE ") > 0) || !!navigator.userAgent.match(/Trident.*rv\:11\./));
  }

  get isOldEdge() {
    return /Edge/.test(window.navigator.userAgent);
  }
}